module.exports = __webpack_public_path__ + "Simple-Line-Icons.f19a7f6c7a0b54b74827.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/line-icons/fonts/Simple-Line-Icons.eot
// module id = ../../../../../src/assets/fonts/line-icons/fonts/Simple-Line-Icons.eot
// module chunks = styles